import { CustomSignaturesConstants } from './customSignature.constants'
import { ICustomFormsSignatureAction, ICustomFormsSignatureState } from './customSignature.types'

export const initialCustomFormsState: ICustomFormsSignatureState = {
  prFormsCustom: [],
  prFormsSignature: [],
  customSignatureClientData: {
    prFormsSignatureObj: {
      formId: null,
      signatureId: null,
      signature: '',
      dt: null,
      seq: null,
      lockForm: null,
      signingReason: '',
      signatoryName: '',
      signatoryRelation: '',
      signatoryPhone: '',
      __name: '',
      __parentName: '',
      __textInfoRequired: 0,
    },
    counter: 0,
    currentSelectedOption: null,
    tempSignature: '',
    acknowledgePrivacyNotice: false,
    term: '',
    acknowledgedPrivacyNotices: [],
    deleteChipId: {
      formId: null,
      signatureId: null,
    },
    signatureType: 'standardSignature',
  },
}

export function customFormsSignatureReducer(
  state: ICustomFormsSignatureState = initialCustomFormsState,
  action: ICustomFormsSignatureAction
): ICustomFormsSignatureState {
  switch (action.type) {
    case CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_CURRENT_SELECTED_OPTION:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          currentSelectedOption: action.currentSelectedOption,
          prFormsSignatureObj: {
            ...state.customSignatureClientData.prFormsSignatureObj,
            formId: action.currentSelectedOption.parentID,
            signatureId: action.currentSelectedOption.id,
            __name: action.currentSelectedOption.name,
            __parentName: action.currentSelectedOption.parentName,
            __textInfoRequired: action.currentSelectedOption.textInfoRequired,
          },
        },
      }
    case CustomSignaturesConstants.SET_SIGNED_CUSTOM_SIGNATURE:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          prFormsSignatureObj: {
            ...state.customSignatureClientData.prFormsSignatureObj,
            signature: action.signature,
          },
        },
      }
    case CustomSignaturesConstants.LOAD_CUSTOM_SIGNATURE_DATA:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          prFormsSignatureObj: action.prFormsSignatureObj,
          tempSignature: `data:image/png;base64,${action.prFormsSignatureObj.signature}`,
        },
      }
    case CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNING_REASON:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          prFormsSignatureObj: {
            ...state.customSignatureClientData.prFormsSignatureObj,
            signingReason: action.signingReason,
          },
        },
      }
    case CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNATORY_NAME:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          prFormsSignatureObj: {
            ...state.customSignatureClientData.prFormsSignatureObj,
            signatoryName: action.signatoryName,
          },
        },
      }
    case CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNATORY_RELATION:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          prFormsSignatureObj: {
            ...state.customSignatureClientData.prFormsSignatureObj,
            signatoryRelation: action.signatoryRelation,
          },
        },
      }
    case CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_SIGNATORY_PHONE:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          prFormsSignatureObj: {
            ...state.customSignatureClientData.prFormsSignatureObj,
            signatoryPhone: action.signatoryPhone,
          },
        },
      }
    case CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_COUNTER:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          counter: action.counter,
        },
      }
    case CustomSignaturesConstants.SAVE_TEMP_SIGNATURE:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          tempSignature: action.tempSignature,
        },
      }
    case CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_ACKNOWLEDGED_PRIVACY_NOTICES:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          acknowledgedPrivacyNotices: action.acknowledgedPrivacyNotices,
        },
      }
    case CustomSignaturesConstants.SET_SELECTED_CHECKBOX:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          acknowledgePrivacyNotice: action.acknowledgePrivacyNotice,
        },
      }
    case CustomSignaturesConstants.SET_CUSTOM_SIGNATURE_TERM:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          term: action.term,
        },
      }
    case CustomSignaturesConstants.SET_DELETE_CHIP_ID:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          deleteChipId: action.deleteChipId,
        },
      }
    case CustomSignaturesConstants.RESET_CUSTOM_SIGNATURE_CLIENT_DATA:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,

          prFormsSignatureObj: {
            formId: null,
            signatureId: null,
            signature: '',
            dt: null,
            seq: null,
            lockForm: null,
            signingReason: '',
            signatoryName: '',
            signatoryRelation: '',
            signatoryPhone: '',
            __name: '',
            __parentName: '',
            __textInfoRequired: 0,
          },
          currentSelectedOption: null,
          tempSignature: '',
          deleteChipId: {
            formId: null,
            signatureId: null,
          },
        },
      }
    case CustomSignaturesConstants.SAVE_CUSTOM_SIGNATURE:
      return { ...state, prFormsSignature: action.prFormsSignature }
    case CustomSignaturesConstants.SAVE_PR_FORMS_CUSTOM:
      return { ...state, prFormsCustom: action.prFormsCustom }
    case CustomSignaturesConstants.SAVE_CUSTOM_SIGNATURE_CLIENT_DATA:
      return { ...state, customSignatureClientData: action.customSignatureClientData }
    case CustomSignaturesConstants.CUSTOM_SIGNATURE_CLEAR_ALL:
      return {
        ...state,
        prFormsCustom: [],
        prFormsSignature: [],
        customSignatureClientData: {
          prFormsSignatureObj: {
            formId: null,
            signatureId: null,
            signature: '',
            dt: null,
            seq: null,
            lockForm: null,
            signingReason: '',
            signatoryName: '',
            signatoryRelation: '',
            signatoryPhone: '',
            __name: '',
            __parentName: '',
            __textInfoRequired: 0,
          },
          counter: 0,
          currentSelectedOption: null,
          tempSignature: '',
          acknowledgePrivacyNotice: false,
          term: '',
          acknowledgedPrivacyNotices: [],
          deleteChipId: {
            formId: null,
            signatureId: null,
          },
          signatureType: 'customSignature',
        },
      }
    case CustomSignaturesConstants.SET_SIGNATURE_TYPE:
      return {
        ...state,
        customSignatureClientData: {
          ...state.customSignatureClientData,
          signatureType: action.signatureType,
        },
      }
    case CustomSignaturesConstants.RESET_CUSTOM_SIGNATURE:
      return {
        prFormsCustom: [],
        prFormsSignature: [],
        customSignatureClientData: {
          prFormsSignatureObj: {
            formId: null,
            signatureId: null,
            signature: '',
            dt: null,
            seq: null,
            lockForm: null,
            signingReason: '',
            signatoryName: '',
            signatoryRelation: '',
            signatoryPhone: '',
            __name: '',
            __parentName: '',
            __textInfoRequired: 0,
          },
          counter: 0,
          currentSelectedOption: null,
          tempSignature: '',
          acknowledgePrivacyNotice: false,
          term: '',
          acknowledgedPrivacyNotices: [],
          deleteChipId: {
            formId: null,
            signatureId: null,
          },
          signatureType: 'standardSignature',
        },
      }
    default:
      return state
  }
}
